const getEvenOddByIndex = index => 0 === index % 2 ? 'odd' : 'even'

export default getEvenOddByIndex